<template>
    <v-container fluid>
                            
        <v-row wrap>

                 <v-col align="center" justify="center" class="text-xs-center">
             
                <v-icon style="font-size:230px;" color="green">done </v-icon>  
                <div class="display-3"><span v-html="$store.state.labels.GoodbyeText"></span></div> 
    
                </v-col>
            
        </v-row>


    </v-container>
</template>
<script>
export default {
       data: () => ({
           loading : false,
           pagamenti:[]
       }),
       computed:{
       },
        methods: {
        },
    mounted() {
        const me  = this;
        this.loading = true;
        let pagamenti_sospesi= false;
              const payload = {
        Comando: "GetElencoTransazioni",
      };
        this.$store.dispatch("APIRequestHR", payload).then(risp => {
            this.loading = false
            if (risp.statusText == "OK") {
                me.pagamenti = risp.data.RISULTATOJSON.ElencoTransazioni;
                if(me.pagamenti.length >0){
                    for(var p in me.pagamenti){
                        if (p.Confermata == "0"){
                            pagamenti_sospesi = true;
                            break;
                        }
                    }
                    
                }
            }

            if(pagamenti_sospesi){
                me.$router.push('/pags')     
            }
            else{
                setTimeout(()=>{
                        me.$router.push('/')
                    }, 5000)
            }
            //console.log(risp,this.loading);
        });


       },
}
</script>
